import React, { Component } from 'react';
import Purchase from '../Purchase';
import PayPurchase from '../PayPurchase';
import Warning from 'notifications/Warning';

class UpgradePurchase extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    const { subId, planId } = this.props;
    if (subId !== oldProps.subId || planId !== oldProps.planId) {
      this.fetchData();
    }
  }

  fetchData() {
    const { subId, planId, createUpgradePurchase } = this.props
    if (subId && planId) {
      createUpgradePurchase(subId, planId);
    }
  }

  render() {
    const { purchase, subId, planId, updatePlan } = this.props;
    if (!purchase || !subId) { return <Warning name="upgradePurchase" /> }

    return (
      <React.Fragment>
        <Purchase id={purchase.id} />
        <PayPurchase id={purchase.id} message={'Your payment was successful and your plan was updated.'} onComplete={() => updatePlan(subId, planId)} />
        <Warning name="upgradePurchase" />
      </React.Fragment>
    )
  }
}

export default UpgradePurchase;
